var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"stats-page flex column gap10 width-all"},[_c('div',{staticClass:"flex space-between gap20 wrap"},[_c('h2',[_vm._v(_vm._s(_vm.$t('statsLocales.stats')))]),_c('div',{staticClass:"statistics-filter flex column_ align-center gap30"},[_c('div',{staticClass:"flex column_ align-center_ gap10"},[_c('FormInput',{attrs:{"type":"date","label":"statsLocales.fromDate"},model:{value:(_vm.datesRange.from),callback:function ($$v) {_vm.$set(_vm.datesRange, "from", $$v)},expression:"datesRange.from"}}),_c('FormInput',{attrs:{"type":"date","label":"statsLocales.toDate"},model:{value:(_vm.datesRange.to),callback:function ($$v) {_vm.$set(_vm.datesRange, "to", $$v)},expression:"datesRange.to"}})],1),_c('ToggleBtns',{attrs:{"value":_vm.timeSelected,"options":[
        {label: _vm.$t('statsLocales.last24Hr'), value: _vm.now - 1000*60*60*24*1},
        {label: _vm.$t('statsLocales.last7Days'), value: _vm.now - 1000*60*60*24*7},
        {label: _vm.$t('statsLocales.lastMonth'), value: _vm.now - 1000*60*60*24*30},
        {label: _vm.$t('statsLocales.lastYear'), value: _vm.now - 1000*60*60*24*365}
      ]},on:{"input":_vm.setTimeToNow},model:{value:(_vm.timeSelected),callback:function ($$v) {_vm.timeSelected=$$v},expression:"timeSelected"}})],1)]),_c('hr'),_c('div',{staticClass:"flex column gap10"},[_c('div',{staticClass:"flex align-center space-between gap10"},[_c('h3',[_vm._v(_vm._s(_vm.$t('statsLocales.watchesPerRelease')))])]),_c('ToggleBtns',{attrs:{"options":[{ label: _vm.$t('statsLocales.numberOfAccountsWatched'), value: 'byAccount' }, { label: _vm.$t('statsLocales.byTotalWatchTimes'), value: 'byTotalWatchTimes' }, { label: _vm.$t('statsLocales.totalWatchTime'), value: 'byTotalWatchTime' }]},model:{value:(_vm.watchBarChartMode),callback:function ($$v) {_vm.watchBarChartMode=$$v},expression:"watchBarChartMode"}}),_c('BarChart',{style:({ height: '500px' }),attrs:{"chart-id":"watchesPerRelease-chart","dataset-id-key":"datasetIdKey","chart-options":{
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            callbacks: {
              title: function(tooltipItems) {
                // Custom hover labels
                const item = Object.values(_vm.watchLogsBarChartDataToShow)[tooltipItems[0].dataIndex];
                if (!Array.isArray(item)) return item.key;
                const hoverLabels = Object.keys(_vm.watchLogsBarChartDataToShow);
                return hoverLabels[tooltipItems[0].dataIndex];
              }
            }
          }
        }
      },"chart-data":{
        labels: Object.keys(_vm.watchLogsBarChartDataToShow).map(c => _vm.cropText(c, 10)),
        datasets: [
          {
            label: '',
            backgroundColor: [_vm.selectedTheme.colors?.[4] || '#00D8FF'],
            data: Object.values(_vm.watchLogsBarChartDataToShow).map(c => Array.isArray(c) ? c.length : c.value)
          }
        ]
      }}})],1),_c('hr'),_c('div',{staticClass:"flex column gap10"},[_c('h3',[_vm._v(_vm._s(_vm.$t('statsLocales.watchesPerMonth')))]),_c('ToggleBtns',{attrs:{"options":[{ label: _vm.$t('statsLocales.totalWatchsCount'), value: 'amount' }, { label: _vm.$t('statsLocales.totalWatchTime'), value: 'time' }]},model:{value:(_vm.monthBarMode),callback:function ($$v) {_vm.monthBarMode=$$v},expression:"monthBarMode"}}),_c('BarChart',{style:({ height: '500px' }),attrs:{"chart-id":"watchesPerMonth-chart","dataset-id-key":"datasetIdKey","chart-options":{
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            callbacks: {
              title: function(tooltipItems) {
                const items = Object.values(_vm.logsMapedByMonths);
                if (_vm.monthBarMode === 'amount') return items.length;
                return items.map(c => c.reduce((acc, _) => acc + _.totalWatchTime, 0)).map(_vm.MsToPretyWatchTime)[tooltipItems[0].dataIndex]
              }
            }
          }
        }
      },"chart-data":{
        labels: Object.keys(_vm.logsMapedByMonths),
        datasets: [
          {
            label: '',
            backgroundColor: [_vm.selectedTheme.colors?.[4] || '#00D8FF'],
            data: _vm.monthBarMode === 'amount'
                ? Object.values(_vm.logsMapedByMonths).map(c => c.length)
                : Object.values(_vm.logsMapedByMonths).map(c => c.reduce((acc, _) => acc + _.totalWatchTime, 0)).map(c => c/1000/60/60)
          }
        ]
      }}})],1),_c('hr'),_c('div',{staticClass:"flex column gap20"},[_c('h3',[_vm._v(_vm._s(_vm.$t('statsLocales.activity')))]),_c('div',{staticClass:"flex gap10 wrap"},[_c('div',{staticClass:"flex column gap10 flex-1"},[_c('h4',[_vm._v(_vm._s(_vm.$t('statsLocales.deviceReport')))]),_c('PieChart',{style:({ height: '200px' }),attrs:{"chart-id":"device-chart","dataset-id-key":"datasetIdKey","chart-options":{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              }
            }
          },"chart-data":{
            labels: Object.keys(_vm.deviceLogsMap),
            datasets: [
              {
                backgroundColor: [_vm.selectedTheme.colors?.[4] || '#00D8FF'],
                data: Object.values(_vm.deviceLogsMap).map(c => c.length)
              }
            ]
          }}})],1),_c('div',{staticClass:"flex column gap10 flex-1"},[_c('h4',[_vm._v(_vm._s(_vm.$t('statsLocales.countryReport')))]),_c('PieChart',{style:({ height: '200px' }),attrs:{"chart-id":"country-chart","dataset-id-key":"datasetIdKey","chart-options":{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              }
            }
          },"chart-data":{
            labels: Object.keys(_vm.countryLogsMap),
            datasets: [
              {
                label: '',
                backgroundColor: [_vm.selectedTheme.colors?.[4] || '#00D8FF'],
                data: Object.values(_vm.countryLogsMap).map(c => c.length)
              }
            ]
          }}})],1)])]),_c('hr'),_c('ReportList'),(_vm.isLoading)?_c('Loader',{attrs:{"fullScreen":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }